// Environment configuration.
// Split from constants.js — edit here, not the barrel.

export const ENV = {
    LOCAL: 'LOCAL',
    DEVELOPMENT: 'DEVELOPMENT',
    PRODUCTION: 'PRODUCTION',
}
